<template>
  <div :class="$vuetify.display.smAndUp ? 'bannerDivLeftSideBar' : 'bannerDiv'">
    <div class="d-flex orangeBar shiftDown"></div>
    <OnexAlert
      border="top"
      id="spanishBanner"
      elevation="2"
      color="orange"
      :value="true"
      data-comp-id="alert-message-warning"
      :type="Notifications.warning"
      :dismissible="false"
    >
      <v-container class="d-flex align-center">
        <v-col cols="11">
          <div class="text-color">
            {{ $t('L_the_language_displayed') }}
            <span @click="openModalSpanishBanner" class="moreInfoLink">{{
              $t('L_more_information')
            }}</span>
          </div>
        </v-col>
        <v-col cols="1" class="text-right mt-2">
          <span class="text-right"
            ><v-icon @click="cancelIcon" color="#333333" :icon="mdiCancel"
          /></span>
        </v-col>
      </v-container>
    </OnexAlert>

    <v-container class="modalPopUp" v-if="showModalPopup">
      <div>
        <v-col cols="12" class="orangeBar2 mt-1" />
        <v-container class="largeBodyWhite">
          <v-col cols="11" />
          <v-col cols="1" class="text-right">
            <span class="text-right mr-2"
              ><v-icon @click="showModalPopup = false" class="cancelIcon" :icon="mdiCancel"
            /></span>
          </v-col>
        </v-container>
        <v-container class="largeBodyWhite justify-space-around">
          <v-col cols="12" class="xs12 pl-3 pr-3 font-weight-bold">
            {{ $t('L_en_policy_and_account_documents_disclosures_and_certain') }}
          </v-col>
        </v-container>
        <v-container class="largeBodyWhite justify-space-around pt-4 pb-5">
          <v-col cols="12" class="pl-3 pr-3 font-weight-bold">
            {{ $t('L_es_policy_and_account_documents_disclosures_and_certain') }}
          </v-col>
        </v-container>
        <div class="largeBodyWhite borderAboveButtonSection mt-2 mb-2">
          <v-container class="text-center">
            <v-col cols="12">
              <OnexButton class="btnOkGotIt" @click="cancelIcon">
                {{ $t('L_en_ok_got_it') }}
              </OnexButton>
            </v-col>
          </v-container>
          <v-container class="text-center pt-2 pb-4">
            <v-col cols="12">
              <span class="moreInfoLink font-weight-bold" @click="cancelIcon">{{
                $t('L_ok_understood')
              }}</span>
            </v-col>
          </v-container>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { mapStores } from 'pinia';
import { type ComponentOptions, defineComponent } from 'vue';
import { mdiCancel } from '@mdi/js';
import { OnexButton, OnexAlert, Notifications } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'SpanishBanner',
  components: {
    OnexButton,
    OnexAlert,
  },
  data: () => ({
    showModalPopup: false,
    mdiCancel,
    Notifications,
  }),
  methods: {
    ...mapStores(useGlobalStore, ['updateSpanishBanner']),
    openModalSpanishBanner() {
      this.showModalPopup = true;
    },
    cancelIcon() {
      this.updateSpanishBanner(false);
    },
  },
};
export default defineComponent(componentOptions);
</script>

<style lang="scss">
#spanishBanner {
  background: #ffffff !important;
  color: black !important;
  display: flex;
  align-items: center;

  .v-alert__border {
    border-color: orange !important;
  }

  .v-icon {
    background-color: #ffffff !important;
    color: orange !important;
  }

  .moreInfoLink {
    color: #063562;
  }

  .topBarForAlert {
    height: 5px;
    background-color: orange;
    margin-bottom: -5px;
    position: fixed;
  }

  .modalPopUp {
    padding-top: 50px;
    position: fixed;
    z-index: 2;
    width: 90%;
    margin: auto;
    background-color: #063562;
    top: 35%;
    left: 5%;
    bottom: 5%;
    border: 2px solid #333333;
    height: auto;
  }

  .orangeBar {
    background-color: orange;
    height: 10px;
  }

  .orangeBar2 {
    background-color: orange;
    height: 7px;
  }

  .largeBodyWhite {
    background-color: #ffffff;
  }

  .bannerDiv {
    position: sticky;
    z-index: 1;
    top: 4rem;
    left: 238px;
    right: 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .bannerDivLeftSideBar {
    position: sticky;
    z-index: 1;
    top: 4rem;
    left: 0;
    right: 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .cancelIcon {
    color: #333333;
    background-color: #ffffff;
  }

  .borderAboveButtonSection {
    border-top: 1px solid #cbcbcb;
    padding-top: 20px;
  }

  .btnOkGotIt {
    width: 280px;
    background-color: #063562 !important;
    color: white !important;
  }

  .shiftDown {
    margin-top: 16px;
    margin-bottom: -7px;
  }
}
</style>
